import uzUZ from "date-fns/locale/uz";

const ShortLinks = {
  month: "Bir oyda",
  threeMonths: "Uch oyda",
  sixMonths: "Yarim yilda",
  year: "Bir yilda",
};

const DateTimeFormats = {
  sunday: "Y",
  monday: "D",
  tuesday: "S",
  wednesday: "Ch",
  thursday: "P",
  friday: "J",
  saturday: "Sh",
  ok: "OK",
  today: "Bugun",
  yesterday: "Kecha",
  now: "Hozir",
  hours: "Soatlar",
  minutes: "Daqiqalar",
  seconds: "Soniyalar",
  formattedMonthPattern: "MMM yyyy",
  formattedDayPattern: "dd MMM yyyy",
  shortDateFormat: "dd/MM/yyyy",
  shortTimeFormat: "HH:mm",
  dateLocale: uzUZ,
};

const Combobox = {
  noResultsText: "Hech qanday natija topilmadi",
  placeholder: "Tanlang",
  searchPlaceholder: "Izlash",
  checkAll: "Hammasi",
};

const CreatableComboBox = {
  ...Combobox,
  newItem: "Yangi element",
  createOption: '"{0}" variantasini yaratish',
};

export const oz = {
  code: "uz",
  common: {
    loading: "Yuklanmoqda...",
    emptyMessage: "Ma'lumot topilmadi",
    remove: "O'chirish",
    clear: "Tozalash",
  },
  Plaintext: {
    unfilled: "To'ldirilmagan",
    notSelected: "Tanlanmagan",
    notUploaded: "Yuklanmagan",
  },
  Pagination: {
    more: "Ko'proq",
    prev: "Oldingi",
    next: "Keyingi",
    first: "Birinchi",
    last: "Oxirgi",
    limit: "{0} / sahifa",
    total: "Jami satrlar: {0}",
    skip: "{0} ga o'tish",
  },
  DateTimeFormats,
  Calendar: DateTimeFormats,
  DatePicker: DateTimeFormats,
  DateRangePicker: {
    ...DateTimeFormats,
    last7Days: "So'nggi 7 kun",
  },
  Combobox,
  InputPicker: CreatableComboBox,
  TagPicker: CreatableComboBox,
  Uploader: {
    inited: "Ishga tushirilgan",
    progress: "Yuklanmoqda",
    error: "Xatolik",
    complete: "To'liq",
    emptyFile: "Bo'sh fayl",
    upload: "Yuklash",
    removeFile: "Faylni o'chirish",
  },
  CloseButton: {
    closeLabel: "Yopish",
  },
  Breadcrumb: {
    expandText: "Yo'lni ko'rsatish",
  },
  Toggle: {
    on: "Ochish",
    off: "Yopish",
  },
  ShortLinks,
};
